<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>
import Vue from "vue";
import {
  mapMutations
} from 'vuex';
//加密解密开始
import AES from "@/utils/AES.js"; // 引入
export default {
  name: 'App',
  created(){
    if(sessionStorage.getItem('user')){
      this.login(sessionStorage.getItem('user'))
    }
  }
  ,methods:{
    ...mapMutations(['login'])
  },watch: {
    "$route.query": {
      immediate: true,
      deep: true,
      handler(val) {
		
		if(val ){
			for (const key in val){
				val[key] = AES.decrypt(val[key])
			}
		}
        Vue.prototype.$route_query = val || {};
      }
    }
  },

}
</script>
<style>
html,body {
  width: 100%;
  margin: 0;
  padding: 0;
}
img{
	object-fit:cover;
}
.video-js .vjs-big-play-button{
	top: calc(50% - 0.7rem)!important;
	left: calc(50% - 1.5rem)!important;
}
.son-title img{
	object-fit: contain!important;
}
.fangda{
	transform: scale(1);
	transition: all 1s; 
}
.fangda:hover{
	transform: scale(1.1);
	transition: all 1s; 
}
body {
  box-sizing: border-box;

}
ul,li {
	list-style: none;
	padding:0;
	margin:0;
}
a {
  text-decoration: none;
  color: #3397de;
}
img {
  width: 100%;
  height: 100%;
}
.z-container {
  width: 1000px;
}
.z-1200 {
  width: 1200px;
 margin: auto;
}
h4,h2,h3,dl,dt,dd,p,h5,h6 {
	padding:0;
	margin: 0;
}
.clearfix:after,.clearfix:before {
    clear:both;
    content:" ";
    display:block;
    height:0;
    line-height:0;
    visibility:hidden;
}
.fl {
  float:left;
}
.fr {
  float:right;
}
.limitText {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}
.limitText2 {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.limitText12 {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 12;
  overflow: hidden;
}
.pages{
	height: 120px;	
	.active{
		background: #FF3C28!important;
	}
	}
.back {
    position: absolute;
    bottom: 20px;
    left: 50px;
    z-index: 999;
}
.row-center{
	display: flex;
	justify-content: center;
	align-items: center;
}
.row-left{
	display: flex;
	justify-content: flex-start;
	align-items: center;
	
}
.row-between{
	display: flex;
	justify-content: space-between;
	align-items: center;
}
.only-one{
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
}
.only-two{
	text-overflow: -o-ellipsis-lastline;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: -webkit-box;
	 -webkit-line-clamp: 2;
	 line-clamp: 2;
	 -webkit-box-orient: vertical;
}
.only-four{
	text-overflow: -o-ellipsis-lastline;
	 overflow: hidden;
	 text-overflow: ellipsis;
	 display: -webkit-box;
	 -webkit-line-clamp: 4;
	 line-clamp: 4;
	 -webkit-box-orient: vertical;
}
.peixun-img,.video-img{
	position: relative;
}
.peixun-img:hover .bo-back,.video-img:hover .bo-back{
	height: 100%!important;
	transition: height 1s;
}
.peixun-img:hover .bo-icon img,.video-img:hover .bo-icon img{
	opacity: 1!important;
	transition: opacity 1s;
}
.bo-back{
	position: absolute;
	top: 0px;
	left: 0px;
	right: 0px;
	width: 100%;
	height: 0px;
	background: rgba(0, 0, 0, 0.5);
	transition: height 1s;
	z-index: 1;
}
.bo-icon{
	position: absolute;
	top: 0px;
	left:0px;
	width: 100%;
	height: 100%;
	
}
.peixun-img .bo-icon img{
	width: 30px;
	height: 30px;
}

.bo-icon img{
	display: flex;
	justify-content: center;
	align-items: center;
	width: 50px;
	height: 50px;
	object-fit: contain;
	z-index: 10;
	opacity: 0.5;
	transition: opacity 1s;
}

</style>



// WEBPACK FOOTER //
// src/App.vue